import {
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
  HttpHandlerFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isApiRequest } from '../_helpers/api-request';

export function httpErrorInterceptor(
  request: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> {
  if (!isApiRequest(request.url)) return next(request);
  const router = inject(Router);

  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 403) {
        const reason = err?.error?.message || err?.error?.err || '';
        if (
          typeof reason === 'string' &&
          reason.includes('ACTING_CONTEXT_REQUIRED')
        ) {
          router.navigate(['/administration/customers']);
        }
      }

      return throwError(() => err);
    }),
  );
}
